import * as React from "react";
import { SectionShell } from "@/components/design-system/SectionShell";
import { SegmentedControl } from "@/components/ui/segmented-control";

const code = `import { SegmentedControl } from "@/components/ui/segmented-control";

const [view, setView] = React.useState("estimate");

<SegmentedControl
  value={view}
  onChange={setView}
  options={[
    { value: "estimate", label: "Estimate" },
    { value: "materials", label: "Materials" },
    { value: "labor", label: "Labor" },
  ]}
/>`;

function PreviewGroup() {
  const [value, setValue] = React.useState("estimate");
  return (
    <SegmentedControl
      value={value}
      onChange={setValue}
      options={[
        { value: "estimate", label: "Estimate" },
        { value: "materials", label: "Materials" },
        { value: "labor", label: "Labor" },
      ]}
    />
  );
}

export function SegmentedControlSection() {
  return (
    <SectionShell
      id="segmented-control"
      title="Segmented control"
      description={
        <>
          FloorCore's pill-track step/tab switcher. One option is always
          active; the active segment lifts to a page-colored card on the
          surface track. Ported from the FloorCore design system.
        </>
      }
      whenToUse={
        <ul>
          <li>Switching between views of the same record or page.</li>
          <li>Step indicators in a short wizard-style flow.</li>
          <li>Exactly-one-active choices in a toolbar.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Multi-select or independent filters — use toggle buttons.
          </li>
          <li>Navigation between pages — use anchors styled as tabs.</li>
          <li>Forms with a persisted value — use <code>&lt;Radio&gt;</code>.</li>
        </ul>
      }
      preview={<PreviewGroup />}
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            <code>options</code> — <code>{"{ value, label }"}</code> pairs;{" "}
            <code>label</code> accepts any React node (icon + text works).
          </li>
          <li>
            Controlled only: pass <code>value</code> +{" "}
            <code>onChange</code>.
          </li>
          <li>
            Rendered with <code>role="tablist"</code> /{" "}
            <code>role="tab"</code> + <code>aria-selected</code>.
          </li>
        </ul>
      }
    />
  );
}
